var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "header d-flex flex-grow-1 justify-space-between align-center"
    },
    [
      _c(
        "div",
        { staticClass: "menu" },
        [_c("single-page-part", { attrs: { pagePart: _vm.headerLeftMenu } })],
        1
      ),
      _c(
        "div",
        { staticClass: "logo" },
        [
          _c("router-link", { attrs: { to: _vm.mainPageUrl } }, [
            _c("img", {
              staticClass: "desc",
              class: { ramadan: _vm.isRamadan },
              attrs: { src: _vm.logotypePath, alt: _vm.mainPageAlt }
            }),
            _c("img", {
              staticClass: "mob",
              class: { ramadan: _vm.isRamadan },
              attrs: { src: _vm.mobileLogotypePath, alt: _vm.mainPageAlt }
            })
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "header__nav" },
        [_vm.user ? _c("the-user-header") : _c("sign-in")],
        1
      ),
      _vm.$store.state.signIn.checkConfirmSignupDialog
        ? _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "900px",
                persistent: _vm.isDialogPersistent
              },
              model: {
                value: _vm.$store.state.signIn.checkConfirmSignupDialog,
                callback: function($$v) {
                  _vm.$set(
                    _vm.$store.state.signIn,
                    "checkConfirmSignupDialog",
                    $$v
                  )
                },
                expression: "$store.state.signIn.checkConfirmSignupDialog"
              }
            },
            [_c("check-confirm-signup")],
            1
          )
        : _vm._e(),
      _vm.$store.state.signIn.successConfirmSignupDialog
        ? _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "900px",
                persistent: _vm.isDialogPersistent
              },
              model: {
                value: _vm.$store.state.signIn.successConfirmSignupDialog,
                callback: function($$v) {
                  _vm.$set(
                    _vm.$store.state.signIn,
                    "successConfirmSignupDialog",
                    $$v
                  )
                },
                expression: "$store.state.signIn.successConfirmSignupDialog"
              }
            },
            [_c("success-confirm-signup")],
            1
          )
        : _vm._e(),
      _vm.$store.state.signIn.failedConfirmSignupDialog
        ? _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "472px",
                persistent: _vm.isDialogPersistent
              },
              model: {
                value: _vm.$store.state.signIn.failedConfirmSignupDialog,
                callback: function($$v) {
                  _vm.$set(
                    _vm.$store.state.signIn,
                    "failedConfirmSignupDialog",
                    $$v
                  )
                },
                expression: "$store.state.signIn.failedConfirmSignupDialog"
              }
            },
            [_c("failed-confirm-signup")],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }